import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiListDataService } from './api.list-data.service';
import { TaskByConsultantModel } from 'core/models/task-by-consultant.model';

@Injectable({
    providedIn: 'root',
})
export class ApiTaskTaskByConsultant extends ApiListDataService<TaskByConsultantModel, any> {
    constructor(http: HttpClient) {
        super(http, '/Task/TaskByConsultant/');
    }
}
